import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { DataGrid, DataGridElement } from '../../../../../lib/components/compound/dataGrid';
import { KeyofNamespace } from '../../../../../translations/keyofNs';
import Util from '../../../../../misc/util';

interface Props {
  data?: Record<string, string | number | null | undefined>;
}

export const PaymentDataView: FC<Props> = ({ data }) => {
  const { t } = useTranslation();

  const renderValue = (key: string) => {
    if (!data) return null;
    switch (key) {
      case 'pricing_model':
      case 'payment_interval':
        return t(`payment:${key}` as KeyofNamespace<'payment'>, { context: data[key] });
      case 'monthly_price_per_employee':
        return Util.formatCurrency(data[key] as number);
      default:
        return data[key];
    }
  };

  return (
    <DataGrid>
      {(data &&
        Object.keys(data)
          .filter((key) => typeof data[key] !== 'object')
          .map((key, index) => (
            <DataGridElement
              key={index}
              title={t(`payment:${key}` as KeyofNamespace<'payment'>)}
              value={renderValue(key)}
            />
          ))) ||
        []}
    </DataGrid>
  );
};
